import styled from 'styled-components';

const LayoutWrapper = styled.div`
  background-color: #f6f6f6;
  margin: 0;
  padding: 0;
  width: 100%;
`;
export default LayoutWrapper;
